import 'core-js/modules/es.object.assign.js';
import { __rest } from '../../../_virtual/_tslib.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import Close from '@mui/icons-material/Close';
import { Snackbar as Snackbar$1 } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Stack, css } from '@mui/system';
import { withUtility, elevation, shape, spacing } from '../../foundation/utils.js';
import '../assist-chip/assist-chip.js';
import { Button } from '../button/button.js';
import '../card/card.js';
import '../checkbox/checkbox.js';
import '../container/container.js';
import '../dialog/dialog.js';
import '../divider/divider.js';
import '../donut/donut.js';
import '@mui/icons-material/ArrowBack';
import '@mui/material/Drawer';
import '@mui/icons-material/ContentCopyRounded';
import '../fast-copy/fast-copy.types.js';
import '../feedback-banner/feedback-banner.js';
import '../filter-chip-select/filter-chip-select.js';
import '../filter-chip/filter-chip.js';
import '../line/line.js';
import '../link/link.js';
import '../logo/logo.js';
import '../menu-list/menu-list.js';
import '../modal/modal.js';
import 'core-js/modules/es.parse-int.js';
import 'react';
import '../pagination/pagination.types.js';
import '../popover/popover.js';
import '../radio/radio.js';
import '../../foundation/theme/theme.js';
import '../select/select.js';
import './snackbar.types.js';
import '../stats/stats.js';
import '../stats/stats.types.js';
import '../switch/switch.js';
import '../table/table.js';
import '../table/table.types.js';
import '../tabs/tabs.js';
import '../tag/tag.js';
import '../tag/tag.types.js';
import '../text-field/text-field.js';
import { Text } from '../text/text.js';
import '../tooltip/tooltip.js';

let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5;
const SnackbarContent = styled(Stack)(_t || (_t = _`
  ${0}

  box-shadow: 0px ${0};
  border-radius: ${0};
  padding: ${0} ${0};
`), withUtility(({
  palette
}, {
  variant
}) => {
  switch (variant) {
    case 'neutral':
      return css(_t2 || (_t2 = _`
          background-color: ${0};
          color: ${0};
          border: 1.5px solid ${0};
          button {
            color: ${0};
          }
        `), palette('surfaceAt1'), palette('onSurface'), palette('surfaceVariant'), palette('onSurface'));
    case 'positive':
      return css(_t3 || (_t3 = _`
          background-color: ${0};
          color: ${0};
          border: 1.5px solid ${0};
          button {
            color: ${0};
          }
        `), palette('successContainer'), palette('onSuccessContainer'), palette('onSuccessContainer'), palette('onSuccessContainer'));
    case 'negative':
      return css(_t4 || (_t4 = _`
          background-color: ${0};
          color: ${0};
          border: 1.5px solid ${0};
          button {
            color: ${0};
          }
        `), palette('errorContainer'), palette('onErrorContainer'), palette('onErrorContainer'), palette('onErrorContainer'));
    case 'informative':
      return css(_t5 || (_t5 = _`
          background-color: ${0};
          color: ${0};
          border: 1.5px solid ${0};
          button {
            color: ${0};
          }
        `), palette('infoContainer'), palette('onInfoContainer'), palette('onInfoContainer'), palette('onInfoContainer'));
  }
  return;
}), elevation('small'), shape('small'), spacing(2.5), spacing(4));
const Snackbar = _a => {
  var {
      variant = 'positive',
      open,
      children,
      closeable = true,
      anchorOrigin = {
        vertical: 'bottom',
        horizontal: 'center'
      },
      onClose,
      autoHideDuration = 6000
    } = _a,
    props = __rest(_a, ["variant", "open", "children", "closeable", "anchorOrigin", "onClose", "autoHideDuration"]);
  return jsx(Snackbar$1, Object.assign({
    anchorOrigin: anchorOrigin,
    open: open,
    autoHideDuration: autoHideDuration,
    onClose: onClose
  }, props, {
    children: jsxs(SnackbarContent, Object.assign({
      variant: variant,
      flexDirection: "row",
      alignItems: "center",
      gap: 6
    }, {
      children: [jsx(Text, Object.assign({
        variant: "body2"
      }, {
        children: children
      })), closeable && jsxs(Button, Object.assign({
        hierarchy: "secondary",
        size: "small",
        variant: "text",
        onClick: onClose,
        p: 0,
        style: {
          height: 'auto'
        }
      }, {
        children: [jsx(Text, Object.assign({
          variant: "caption"
        }, {
          children: "Fechar"
        })), " ", jsx(Close, {
          fontSize: "small"
        })]
      }))]
    }))
  }));
};

export { Snackbar };
